import React, { useState } from "react";
import { Formik, ErrorMessage } from "formik";
import { TextField, MenuItem, Chip } from "@material-ui/core";

import { fieldsName, partnerStatus } from "../constant";
import { DataLoader } from "../../../components/loader";
import { partnerFormShema } from "./validation-schema";
import {
  handleFormValueChange,
  useHandleFieldFocus,
} from "../../../utils/form";
import { fileContext } from "../../../constants";
import ProgressChip from "../../../components/progress-chip";
import { useUploadFiles } from "../../../utils/upload-file/hooks";
import SketchColorPickerField from "../../../components/color-picker";

const formField = {
  brand_name: "",
  status: "",
  color_code: "",
};

const PartnerForm = ({ fieldValues, handlePartnerForm, btn, isLoading }) => {
  const { focusField, handleFocusField, handleBlurField } =
    useHandleFieldFocus();
  const {
    uploadError,
    handleDeleteAFile,
    files,
    isFileUploadData,
    uploadProgress,
    handlePartnerLogoFile,
  } = useUploadFiles();

  const [formValues, setFormValues] = useState(fieldValues || formField);

  const { brand_name, color_code, status, logo } = fieldsName;

  const handleFormUpdate = (name, value) => {
    setFormValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  return (
    <Formik
      validateOnMount
      validationSchema={partnerFormShema}
      enableReinitialize
      initialValues={{
        brand_name: formValues?.brand_name || "",
        color_code: formValues?.color_code || "#ff4861",
        status: formValues?.status || "",
        logo: files.filter((file) => file.file_context === fileContext.LOGO),
      }}
      onSubmit={handlePartnerForm}
    >
      {({ handleSubmit, setFieldValue, ...rest }) => (
        <>
          {isLoading ? <DataLoader /> : null}
          <form
            className="material-form"
            onSubmit={handleSubmit}
            autoComplete="off"
          >
            <div className="materila-form_inline-child">
              <TextField
                className="material-form__field"
                name={brand_name}
                placeholder="Brand Name"
                label="Brand Name"
                value={rest.values.brand_name}
                onChange={(e) => {
                  const { name, value } = e.target;
                  handleFormUpdate(name, value);
                  handleFormValueChange(rest, brand_name);
                }}
                onFocus={() => handleFocusField(brand_name)}
                onBlur={() => handleBlurField()}
              />

              {focusField === brand_name ? null : (
                <ErrorMessage
                  render={(msg) => (
                    <div className="material-form__error">{msg}</div>
                  )}
                  name={brand_name}
                />
              )}
            </div>

            <div className="materila-form_inline-child">
              <TextField
                className="material-form__field"
                name={status}
                placeholder="Status"
                label="Status"
                select
                value={rest.values.status}
                onChange={(e) => {
                  const { name, value } = e.target;
                  handleFormUpdate(name, value);
                  handleFormValueChange(rest, status);
                }}
                onFocus={() => handleFocusField(status)}
                onBlur={() => handleBlurField()}
                defaultValue={rest.values.status}
              >
                {partnerStatus.map((status) => (
                  <MenuItem
                    key={status.id}
                    className="material-form__option"
                    value={status.value}
                  >
                    {status.displayText}
                  </MenuItem>
                ))}
              </TextField>
              {focusField === status ? null : (
                <ErrorMessage
                  render={(msg) => (
                    <div className="material-form__error">{msg}</div>
                  )}
                  name={status}
                />
              )}
            </div>

            <div className="mb-3">
              <SketchColorPickerField
                value={rest?.values?.color_code}
                onChange={(color) => {
                  handleFormValueChange(rest, color_code);
                  setFieldValue(color_code, color);
                  handleFormUpdate(color_code, color);
                }}
                name={color_code}
                label={"Strip Color Code"}
              />
            </div>

            <div className="form__form-group-field form__margin-bottom">
              <div className="form__form-group-input-wrap">
                <div className="form__form-group-file">
                  <label htmlFor="logo">Logo</label>
                  {files
                    .filter((file) => file.file_context === fileContext.LOGO)
                    .map((x) => {
                      return (
                        <Chip
                          className="selected-file"
                          key={x.uuid_file_name}
                          label={x.original_file_name}
                          onDelete={() => handleDeleteAFile(x)}
                          variant="outlined"
                        />
                      );
                    })}

                  {isFileUploadData
                    .filter((file) => file.fileContext === fileContext.LOGO)
                    .map((x, i) => {
                      return (
                        <div key={i}>
                          {x.isUpload && (
                            <ProgressChip
                              fileName={x.fileName}
                              uploadProgress={uploadProgress}
                            />
                          )}
                        </div>
                      );
                    })}

                  <input
                    accept="image/*"
                    onBlur={rest.handleBlur}
                    type="file"
                    name={logo}
                    id="logo"
                    onClick={(event) => {
                      event.target.value = null;
                    }}
                    onChange={(event) => {
                      handlePartnerLogoFile(
                        event.currentTarget.files,
                        fileContext.LOGO
                      );
                      setFieldValue(
                        logo,
                        files.filter(
                          (file) => file.file_context === fileContext.LOGO
                        )
                      );
                    }}
                  />
                </div>
                {rest.errors.logo ? (
                  <ErrorMessage
                    render={(msg) => (
                      <div className="material-form-error-image">{msg}</div>
                    )}
                    name={logo}
                  />
                ) : (
                  <div className="material-form-error-image">{uploadError}</div>
                )}
              </div>
            </div>

            <button type="submit" className="btn btn-success btn-right btn-sm">
              {btn}
            </button>
          </form>
        </>
      )}
    </Formik>
  );
};

export default PartnerForm;
